import { Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { createTest, selectTest, setExamId } from '../../../store/testSelectionSlice';
import { resetExam, setSection, updateQuestionData } from '../../../store/ExamSlice';
import { useDispatch, useSelector } from 'react-redux';

import { Api } from '@mui/icons-material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PathCard from './PathCard';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SearchIcon from '@mui/icons-material/Search';
import SftAiPathIcon from '../../../assets/SftAiPathIcon.svg';
import axiosRequestInterceptor from '../../../interceptor/axiosAPIRequestInterceptor';
import { getAiPath } from '../../../services/AiPathService';
import { logger } from '../../../utils/logger';
import { useNavigate } from 'react-router-dom';

// const kcDataMath = [
// 	{
// 		topicId: '3bfb2a9-1d0b-4f91-a6cb-1c84cd246a5a',
// 		subtopicId: '1abfbf1d-b013-468f-a3bc-3193db8d8cc7',
// 		title: 'Percentages',
// 		progress: 35,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: '5e9b27a6-66c3-4df2-9ad3-381d21ef8a53',
// 		subtopicId: '3c1432e7-e701-4482-89f1-b270798cc2d4',
// 		title: 'Circles',
// 		progress: 25,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: '5e9b27a6-66c3-4df2-9ad3-381d21ef8a53',
// 		subtopicId: '137c29b5-87c1-4a58-819e-1178d0b0b09d',
// 		title: 'Area and volume',
// 		progress: 45,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: '5e9b27a6-66c3-4df2-9ad3-381d21ef8a53',
// 		subtopicId: '137c29b5-87c1-4a58-819e-1178d0b0b09d',
// 		title: 'Area and volume',
// 		progress: 45,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: '5e9b27a6-66c3-4df2-9ad3-381d21ef8a53',
// 		subtopicId: '137c29b5-87c1-4a58-819e-1178d0b0b09d',
// 		title: 'Area and volume',
// 		progress: 45,
// 		mastery: 'Low Mastery',
// 	},
// ];

// const kcDataReadingWriting = [
// 	{
// 		topicId: 'e214b1f4-ec56-4d87-9270-5f74b690a560',
// 		subtopicId: '9d0e9389-f95e-4dbf-a4cb-d1dd18f31b33',
// 		title: 'Words in Context',
// 		progress: 15,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: 'ed8bcf17-1e57-4052-8e5b-4f4c82d45c80',
// 		subtopicId: 'fb01ef96-10a1-4a55-b3e8-b882cfb83f99',
// 		title: 'Boundaries',
// 		progress: 25,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: '9e5e1dcb-259d-4ae8-a5d9-02a6c28bc86b',
// 		subtopicId: 'ec1a5a91-59a7-4fdf-a4a4-067dfe530113',
// 		title: 'Inferences',
// 		progress: 35,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: '9e5e1dcb-259d-4ae8-a5d9-02a6c28bc86b',
// 		subtopicId: 'ec1a5a91-59a7-4fdf-a4a4-067dfe530113',
// 		title: 'Inferences',
// 		progress: 35,
// 		mastery: 'Low Mastery',
// 	},
// 	{
// 		topicId: '9e5e1dcb-259d-4ae8-a5d9-02a6c28bc86b',
// 		subtopicId: 'ec1a5a91-59a7-4fdf-a4a4-067dfe530113',
// 		title: 'Inferences',
// 		progress: 35,
// 		mastery: 'Low Mastery',
// 	},
// ];

const AIPathDashboard = () => {
	const { userId } = useSelector((state) => state.userDetails);
	const api = axiosRequestInterceptor;
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [aiPath, setAiPath] = useState({
		READING_WRITING: [],
		MATHS: [],
	});

	// const kcDataReadingWritinggrouped = [];
	// const kcDataMathgrouped = [];
	const [kcDataReadingWritinggrouped, setKcDataReadingWritinggrouped] = useState({});
	const [kcDataMathgrouped, setKcDataMathgrouped] = useState({});

	useEffect(() => {
		const fetchAiPathData = async () => {
			try {
				const response = await getAiPath(userId);
				setAiPath(response);
				if (response?.READING_WRITING?.length !== 0) {
					let temp = {};
					for (const item of response.READING_WRITING) {
						const topicId = item.topicId; // ✅ No error
						const subtopicId = item.subtopicId;
						if (!temp[topicId]) {
							temp[topicId] = { topicId, subtopics: [] };
						}
						temp[topicId].subtopics.push({
							id: subtopicId,
							count: 1,
						});
					}
					setKcDataReadingWritinggrouped(Object.values(temp));
				}
				if (response?.MATHS?.length !== 0) {
					let temp = {};
					for (const item of response.MATHS) {
						const topicId = item.topicId; // ✅ No error
						const subtopicId = item.subtopicId;
						if (!temp[topicId]) {
							temp[topicId] = { topicId, subtopics: [] };
						}
						temp[topicId].subtopics.push({
							id: subtopicId,
							count: 1,
						});
					}
					setKcDataMathgrouped(Object.values(temp));
				}
			} catch (error) {
				logger.error('Error fetching AI Path data:', error);
			}
		};
		fetchAiPathData();
	}, []);

	// for (let i = 0; i < 5; i++) {
	// 	var topicId = aiPath.MATHS?.[i].topicId;
	// 	var subtopicId = aiPath.MATHS?.[i].subtopicId;
	// 	if (!kcDataMathgrouped[topicId]) {
	// 		kcDataMathgrouped[topicId] = { topicId, subtopics: [] };
	// 	}
	// 	kcDataMathgrouped[topicId].subtopics.push({ id: subtopicId, count: 1 });

	// 	var topicId = aiPath.READING_WRITING?.[i].topicId; // ✅ No error
	// 	var subtopicId = aiPath.READING_WRITING?.[i].subtopicId;
	// 	if (!kcDataReadingWritinggrouped[topicId]) {
	// 		kcDataReadingWritinggrouped[topicId] = { topicId, subtopics: [] };
	// 	}
	// 	kcDataReadingWritinggrouped[topicId].subtopics.push({ id: subtopicId, count: 1 });
	// }

	const createSFT = async (section) => {
		// const sections = { READING_WRITING: 1, MATHS: 2 };
		const testType = section === 1 ? 'READING_WRITING' : 'MATHS';

		// const section = sections?.[selectedMainTab];
		// logger.log('Creating SFT with payload:', payload);
		logger.log('readingWriting grouped data:', kcDataReadingWritinggrouped);
		try {
			const response = await api.post(`/sft/createSFTTest`, {
				userId: userId,
				testType: testType,
				topicDistribution: section === 1 ? kcDataReadingWritinggrouped : kcDataMathgrouped,
				// ...payload,
			});
			if (!response.data.success) {
				console.warn('API Warning:', response.data.message); // Log warning without crashing
				return null; // Prevent UI error popups
			}
			logger.log('Test created', response.data?.test?.questions);
			dispatch(selectTest('SFT'));
			dispatch(setExamId(response.data?.testId));
			dispatch(updateQuestionData(response.data?.test));
			dispatch(setSection(section));
			dispatch(
				createTest({
					testType: testType,
					topicDistribution:
						section === 1 ? kcDataReadingWritinggrouped : kcDataMathgrouped,
				})
			);
			navigate('/test-instructions');
		} catch (error) {
			console.error('Error creating test: ', error?.response?.data?.message);
			// throw error;
			alert(error?.response?.data?.message);
			dispatch(resetExam());
		}
	};
	return (
		<Box sx={{ p: { xs: 2, sm: 4 }, maxWidth: '100vw', overflowX: 'hidden' }}>
			{/* CSS Grid Layout using Box */}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					textAlign: 'left',
					mb: 4,
					// marginLeft: '8%',
				}}
			>
				<Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
					Today's Recommended KC Queue
				</Typography>
				<Typography
					variant="body2"
					color="text.secondary"
					gutterBottom
					sx={{ fontWeight: 'bold' }}
				>
					Practice these knowledge components (KCs) identified by the AI model:
				</Typography>
			</Box>
			{/* <Box
				display="grid"
				gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr 1fr' }}
				gap={8}
				sx={{ marginLeft: '8%', marginTop: '2%', width: '100%' }}
			> */}
			<Box
				// display="grid"
				// gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr 1fr' }}
				// gap={8}
				sx={{
					// marginLeft: '8%',
					marginTop: '2%',
					width: '100%',
					display: 'flex',
					flexDirection: { xs: 'column', sm: 'row' },
					gap: 8,
					maxWidth: '100%',
				}}
			>
				{/* Recommended KC Queue */}

				<Box>
					<Stack direction="row" spacing={8} sx={{ flex: 1, pt: 2 }}>
						<Stack spacing={2}>
							<Typography
								variant="h6"
								gutterBottom
								sx={{ fontWeight: 'bold', textAlign: 'left' }}
							>
								Reading and Writing States
							</Typography>
							{/* <Typography variant="body2" color="text.secondary" gutterBottom>
								Practice these knowledge components (KCs) identified by the AI
								model:
							</Typography> */}
							{aiPath.READING_WRITING?.map((kc, index) => (
								// <Card key={index} variant="outlined" sx={{ padding: 2 }}>
								// 	<CardContent>
								// 		<Box
								// 			display="flex"
								// 			justifyContent="space-between"
								// 			alignItems="center"
								// 			mb={1}
								// 		>
								// 			<Typography variant="subtitle1" fontWeight="bold">
								// 				{kc.title}
								// 			</Typography>
								// 			<Chip label={kc.mastery} color="error" size="small" />
								// 		</Box>

								// 		{/* <Typography
								//       variant="body2"
								//       color="text.secondary"
								//       gutterBottom
								//     >
								//       {kc.progress[0]}% → {kc.progress[1]}% → {kc.progress[2]}%
								//     </Typography> */}

								// 		<Stack direction="row" spacing={2} mt={1}>
								// 			<Button
								// 				variant="contained"
								// 				startIcon={<SearchIcon />}
								// 				size="small"
								// 				sx={{ backgroundColor: '#1a237e' }}
								// 			>
								// 				Learn
								// 			</Button>
								// 			<Button
								// 				variant="contained"
								// 				startIcon={<PlayArrowIcon />}
								// 				size="small"
								// 				sx={{ backgroundColor: '#1a237e' }}
								// 			>
								// 				Quiz
								// 			</Button>
								// 			<Button
								// 				variant="contained"
								// 				startIcon={<AssignmentIcon />}
								// 				size="small"
								// 				sx={{ backgroundColor: '#1a237e' }}
								// 			>
								// 				Flashcards
								// 			</Button>
								// 		</Stack>
								// 	</CardContent>
								// </Card>
								<PathCard index={index} kc={kc} />
							))}
						</Stack>
					</Stack>
				</Box>
				<Box>
					<Stack direction="row" spacing={8} sx={{ flex: 1, pt: 2 }}>
						<Stack spacing={2}>
							<Typography
								variant="h6"
								gutterBottom
								sx={{ fontWeight: 'bold', textAlign: 'left' }}
							>
								Maths
							</Typography>
							{/* <Typography variant="body2" color="text.secondary" gutterBottom>
								Practice these knowledge components (KCs) identified by the AI
								model:
							</Typography> */}
							{aiPath.MATHS?.map((kc, index) => (
								<PathCard index={index} kc={kc} /> // Using the PathCard component
							))}
						</Stack>
					</Stack>
				</Box>

				{/* Smart Testing Strategy */}
				<Box sx={{ width: { xs: '100%', sm: '30%' }, height: 'fit-content' }}>
					<Card sx={{ height: '100%' }}>
						<CardContent>
							<Typography
								variant="h6"
								gutterBottom
								sx={{ fontWeight: 'bold', textAlign: 'left' }}
							>
								SFT Test
							</Typography>
							{/* <Typography variant="body2" color="text.secondary" gutterBottom>
								Based on your performance, here’s the <strong>suggested</strong>{' '}
								type of SAT practice test for you today.
							</Typography> */}
							<Box
								sx={{
									height: '100%',
									alignItems: 'center',
									justifyContent: 'center',
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<Box
									sx={{
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										mt: 3,
										p: 2,
										border: '1px solid #e0e0e0',
										borderRadius: '12px',
										backgroundColor: '#fff',
										width: '100%',
										maxWidth: '100%',
									}}
								>
									<Box
										sx={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
										}}
									>
										<Box sx={{ mr: 2 }}>
											<img src={SftAiPathIcon} alt="Test Icon" />
										</Box>
										<Box
											sx={{
												display: 'flex',
												flexDirection: 'column',
												textAlign: 'left',
											}}
										>
											<Typography variant="subtitle1" fontWeight="bold">
												Reading & Writing SFT Test
											</Typography>
											<Typography variant="body2" color="text.secondary">
												Comprehensive Practice
											</Typography>
										</Box>
									</Box>
									<Box sx={{ marginLeft: '1rem' }}>
										<Button
											variant="contained"
											color="primary"
											onClick={() =>
												createSFT(
													// {
													// 	testType: 'READING_WRITING',
													// 	topicDistribution:
													// 		kcDataReadingWritinggrouped,
													// },
													1
												)
											}
										>
											Start
										</Button>
									</Box>
								</Box>
								<Box
									mt={3}
									p={2}
									display="flex"
									justifyContent="space-between"
									alignItems="center"
									sx={{
										border: '1px solid #e0e0e0',
										borderRadius: '12px',
										backgroundColor: '#fff',
										width: '100%',
									}}
								>
									<Box
										sx={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
										}}
									>
										<Box sx={{ mr: 2 }}>
											<img src={SftAiPathIcon} alt="Test Icon" />
										</Box>
										<Box
											sx={{
												display: 'flex',
												flexDirection: 'column',
												textAlign: 'left',
											}}
										>
											<Typography variant="subtitle1" fontWeight="bold">
												Maths SFT Test
											</Typography>
											<Typography variant="body2" color="text.secondary">
												Comprehensive Practice
											</Typography>
										</Box>
									</Box>
									<Button
										variant="contained"
										color="primary"
										onClick={() =>
											createSFT(
												// {
												// 	testType: 'MATHS',
												// 	topicDistribution: kcDataMathgrouped,
												// },
												2
											)
										}
									>
										Start
									</Button>
								</Box>
							</Box>
						</CardContent>
					</Card>
				</Box>
			</Box>
		</Box>
	);
};

export default AIPathDashboard;
